import React, { useState } from 'react';

import { Modal } from 'antd-v5';
import { Button, Input } from 'scouting-ui/lib';
import { Editor } from 'slate';
import { useSlate } from 'slate-react';

import { intl } from '@shared/localization';

import styles from './EditorTextArea.less';
import {
  insertLink,
  isLinkActive,
  onPointerDown,
  unwrapLink,
} from './EditorTextArea.utils';
import { getIcon } from './Icon';

const LinkButton = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const editor = useSlate();

  const toggleModal = () => setModalVisible(state => !state);

  const onClick = () => {
    const { selection } = editor;
    if (isLinkActive(editor)) {
      unwrapLink(editor);
      return;
    }

    if (selection) {
      setTitle(Editor.string(editor, selection));
    }

    toggleModal();
  };

  const onOk = () => {
    insertLink(editor, url, title);
    toggleModal();
    setTitle('');
    setUrl('');
  };

  return (
    <>
      <Button
        data-test-id="block-button-link"
        ghost={!isLinkActive(editor)}
        icon={getIcon('link')}
        onClick={onClick}
        onPointerDown={onPointerDown}
        size="small"
      />
      <Modal
        centered
        onCancel={toggleModal}
        onOk={onOk}
        open={modalVisible}
        title={intl.formatMessage({ id: 'EditorTextArea.modalTitle' })}
      >
        <Input
          placeholder={intl.formatMessage({ id: 'EditorTextArea.title' })}
          className={styles.modalInput}
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <Input
          placeholder={intl.formatMessage({ id: 'EditorTextArea.url' })}
          className={styles.modalInput}
          value={url}
          onChange={e => setUrl(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default LinkButton;
